/* eslint-disable jsx-a11y/alt-text */
import React, { Component, Fragment } from 'react';
import { shopContext } from '../../contexts/aniplus';
import { withRouter } from 'react-router-dom';
import axios from 'axios';

//import NewContentList from './NewContentList'
import moment from 'moment';
import '../../css/event20210317.css';

class Event202104_contentList extends Component {
  state = {
    //eventCode: 0,
    intReturn: -101,
  };
  componentDidMount = () => {
    this._getClear();
  };
  _getClear = async () => {
    //해당일의 이벤트 내용과, 참여 및 클리어 여부에 따른 작품 목록 가져올것.
    const { loginId } = this.props;
    const { eventCode } = this.props.childProps;
    //console.log(eventCode)
    const curDate = new Date();
    const today = moment(curDate).format('YYYY-MM-DD HH:mm:ss');

    if (today <= '2021-03-31 00:00:00') {
      if (loginId === '' || loginId === null || loginId === undefined) {
        //console.log('login....')
      } else {
        if (
          eventCode === '' ||
          eventCode === 0 ||
          eventCode === undefined ||
          eventCode === null
        ) {
        } else {
          const result = await this._getClearApi();
          const intReturn = result.data[0].intReturn;

          //console.log(intReturn)
          if (intReturn === 0) {
            this._getContentList(eventCode);
          }
        }
      }
    } else {
      if (
        eventCode === '' ||
        eventCode === 0 ||
        eventCode === undefined ||
        eventCode === null
      ) {
      } else {
        const result = await this._getClearApi();
        const intReturn = result.data[0].intReturn;

        //console.log(intReturn)
        if (intReturn === 0) {
          this._getContentList(eventCode);
        }
      }
    }
  };

  _getClearApi = () => {
    const { apiUrl, loginId } = this.props;
    const { eventCode } = this.props.childProps;

    return axios
      .post(apiUrl + '/event_202104_clear', {
        params: {
          eventCode: eventCode,
          userid: loginId,
        },
      })
      .then((resposne) => resposne)
      .catch((error) => {
        //console.log('error...')
      });
  };

  _getContentList = async (eventCode) => {
    const { loginId } = this.props;

    const curDate = new Date();
    const today = moment(curDate).format('YYYY-MM-DD HH:mm:ss');

    if (today <= '2021-03-31 00:00:00') {
      if (loginId === '' || loginId === null || loginId === undefined) {
      } else {
        const result = await this._getContentListApi(eventCode);
        const intReturn = result.data[0].intReturn;
        const contentList = result.data[0].listData;

        //console.log(contentList)

        if (intReturn === 0) {
          this.setState({
            intReturn,
            contentList,
          });
        }
      }
    } else {
      const result = await this._getContentListApi(eventCode);
      const intReturn = result.data[0].intReturn;
      const contentList = result.data[0].listData;

      //console.log(contentList)

      if (intReturn === 0) {
        this.setState({
          intReturn,
          contentList,
        });
      }
    }
  };

  _getContentListApi = (eventCode) => {
    const { apiUrl, loginId } = this.props;

    return axios
      .post(apiUrl + '/event_202104_content', {
        params: {
          eventCode: eventCode,
          userid: loginId,
        },
      })
      .then((response) => response)
      .catch((error) => {
        //console.log('error...')
      });
  };
  _renderItem = () => {
    const { contentList } = this.state;

    const list = contentList.map((item, index) => {
      return (
        <li key={index}>
          <div
            className="ani"
            onClick={() => this._goContent(item.contentSerial)}
            style={{ cursor: 'pointer' }}
          >
            <div className="thumb">
              <img src={item.img} />
            </div>
            <div className="info">
              <p className="date">{item.comment}</p>
              <p className="subject">{item.title}</p>
            </div>
          </div>
        </li>
      );
    });

    return list;
  };
  _renderNull = () => {
    const { eventCode } = this.props.childProps;
    const { imgUrl } = this.props;

    let test = [];

    if (eventCode === 1) {
      test = [0, 1];
    } else if (eventCode === 2) {
      test = [0, 1, 2];
    } else if (eventCode === 3) {
      test = [];
    } else if (eventCode === 4) {
      test = [0, 1];
    } else if (eventCode === 5) {
      test = [0];
    }

    const list = test.map((item, index) => {
      return (
        <li key={index}>
          <div className="ani none">
            <img src={imgUrl + '/img/event/20210317/null_img.png'} />
          </div>
        </li>
      );
    });
    return list;
  };
  _goContent = (contentSerial) => {
    const { setContentSerial } = this.props;
    setContentSerial(contentSerial);
  };
  render() {
    const { intReturn, contentList } = this.state;
    const { eventCode } = this.props.childProps;
    const { imgUrl } = this.props;

    let title = '';

    if (eventCode === 1) {
      title = '3/26';
    } else if (eventCode === 2) {
      title = '3/27';
    } else if (eventCode === 3) {
      title = '3/28';
    } else if (eventCode === 4) {
      title = '3/29';
    } else if (eventCode === 5) {
      title = '3/30';
    }
    return (
      <Fragment>
        {intReturn === 0 ? (
          <ul className="list">
            {contentList ? this._renderItem() : null}
            {contentList ? this._renderNull() : null}
          </ul>
        ) : (
          <Fragment>
            <div
              className="release"
              style={{ marginTop: eventCode === 1 ? 130 : 0 }}
            >
              MISSION OPEN : {title}
            </div>
            <ul className="list aniline">
              <li>
                <div className="ani none">
                  <img src={imgUrl + '/img/event/20210317/null_img.png'} />
                </div>
              </li>
              <li>
                <div className="ani none">
                  <img src={imgUrl + '/img/event/20210317/null_img.png'} />
                </div>
              </li>
              <li>
                <div className="ani none">
                  <img src={imgUrl + '/img/event/20210317/null_img.png'} />
                </div>
              </li>
              <li>
                <div className="ani none">
                  <img src={imgUrl + '/img/event/20210317/null_img.png'} />
                </div>
              </li>
              <li>
                <div className="ani none">
                  <img src={imgUrl + '/img/event/20210317/null_img.png'} />
                </div>
              </li>
              <li>
                <div className="ani none">
                  <img src={imgUrl + '/img/event/20210317/null_img.png'} />
                </div>
              </li>
            </ul>
          </Fragment>
        )}
      </Fragment>
    );
  }
}

export default shopContext(withRouter(Event202104_contentList));
